import { useMatch } from 'react-router-dom';

import { paths } from '../../paths';
import { isDefined } from '../is';

export const useIsLookbook = () => {
  return isDefined(useMatch({ end: false, path: paths.LOOKBOOK }));
};
